<template>
  <div class="item" id="pg-grade">
    <div class="left" data-toggle="collapse" data-target="#item-grade" aria-expanded="true" aria-controls="item-grade">
      <p class="text-add-course">Grade</p>
    </div>
    <div id="item-grade" class="text-center rigth collapse width"  aria-labelledby="pg-grade" data-parent="#pg-add-course">
      <div class="content-info">
        <div class="form-info">

          <div class="grade-grid row">
            <add-course-grade-list @loadData="loadData" />
            <add-course-grade-screen :currentClass="current" />
          </div>

          <button @click="cleanCourse">Limpar</button>

          <div class="d-flex justify-content-between mt-1">
            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-requirements"
              aria-expanded="true"
              aria-controls="item-requirements"
            ><< Requirimentos</button>

            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-tags"
              aria-expanded="true"
              aria-controls="item-tags"
            >Tags >></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import List from './Grade/List'
import Screen from './Grade/Screen'

export default {
  name: 'add-course-grade',
  data () {
    return {
      current: {},
    }
  },
  methods: {
    ...mapActions({
      cleanCourse: "cleanCourse"
    }),

    loadData: function ( item ) {
      this.current = item
    },
  },
  components: {
    "add-course-grade-list": List,
    "add-course-grade-screen": Screen
  }
}
</script>
